import PropTypes from 'prop-types';
import React from 'react';
import uniqueId from 'lodash/uniqueId';
import { compose, withProps, lifecycle, withState } from 'recompose';
import classnames from 'classnames';

import { INDETERMINATE } from './constants';
import Icon, { GLYPHS } from './icon';

const Checkbox = ({
  className,
  label,
  onChange,
  onClick,
  checked,
  disabled,
  children,
  value,
  name,
  id,
  onBlur,
  small,
  type,
  inputRef,
  loading,
  inputClassName,
  automationId,
}) => (
  <div
    className={classnames('c-checkbox u-mr', { 'c-checkbox--small': small, 'c-checkbox--loading': loading }, className)}
  >
    <input
      className={classnames('c-checkbox__input', { 'is-indeterminate': value === INDETERMINATE }, inputClassName)}
      type={type}
      disabled={disabled}
      checked={checked}
      id={id}
      onChange={onChange}
      onClick={onClick}
      value={value}
      name={name}
      onBlur={onBlur}
      ref={inputRef}
    />
    <label className="c-checkbox__label" htmlFor={id}>
      <span className="c-checkbox__trigger" />
      <span className="c-checkbox__text" display-if={label || children} data-automation-id={automationId}>
        {label || children}
      </span>
    </label>
    <div className="c-checkbox__loader" display-if={loading}>
      <Icon glyph={GLYPHS.spinner} className="o-icon--small" />
    </div>
  </div>
);
Checkbox.propTypes = {
  inputClassName: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  name: PropTypes.string,
  id: PropTypes.string, // eslint-disable-line react/require-default-props
  small: PropTypes.bool,
  type: PropTypes.string,
  inputRef: PropTypes.any,
  loading: PropTypes.bool,
  automationId: PropTypes.string,
};
Checkbox.defaultProps = {
  inputClassName: undefined,
  className: undefined,
  type: 'checkbox',
  label: '',
  children: null,
  onChange: () => null,
  onClick: () => null,
  onBlur: () => null,
  checked: null,
  disabled: false,
  value: '',
  name: '',
  small: false,
  inputRef: undefined,
  loading: false,
  automationId: null,
};

export default compose(
  withState('generatedId', 'setGeneratedId', ''),
  lifecycle({
    componentWillMount() {
      if (!this.props.id) {
        this.props.setGeneratedId(uniqueId('checkbox-'));
      }
    },
  }),
  withProps(props => ({
    id: props.id || props.generatedId,
  }))
)(Checkbox);
